import React, { useState,useEffect } from 'react';
import { Singleton } from '../../../js/Singleton';
import { APIFactory } from 'cw-galatea-api-js/cw-galatea-api-js-bundle.js'
import {useInfiniteScrollWithRefCallback,formatDateWithHour} from 'global-components-library';
import { Spinner } from 'reactstrap';
import { LANGUAGE } from '../../../constants';
import { SingletonSharedData } from '../../../js/singletonSharedData';
import { useSelector, useDispatch } from 'react-redux';
import { saveLogDial, setFlagLogDial } from '../../../redux/actions/A_preview';
import { Logger } from '../../../js/helpers/Logger';
import { RECORD_STATE } from '../../../constants';

const language = new Singleton();
const  APIFact = new APIFactory();
const apiCont = APIFact.buildClient();
const sharedData = new SingletonSharedData();

const DialingLogPreview=({userId,showDataLogDisp=false, callOutId, camId,status,showOnlyData})=> {
  const idLanguage = language.getLanguage();
  const [dialingLog, setDialingLog] = useState([]);
  const[iRow,setIRow] = useState(1);
  const[fRow,setFRow] = useState(6);
  const[flag,setFlag] = useState(false);
  const[lang,setLang] = useState(LANGUAGE[sharedData.generalPermissions[27]]);
  const[rigthSideStyle, setRigthSideStyle] = useState('');
  const wrapUpStyle = [RECORD_STATE.WRAPUP, RECORD_STATE.ABANDONED, RECORD_STATE.ALERT,RECORD_STATE.WAITING_WRAPUP];
  const { simultaneosRecs, records, selectedRecord} = useSelector(state=>state.preview);
  const dispatch = useDispatch();

  const [containerRef, isFetchingPage, setFetchingPage] = useInfiniteScrollWithRefCallback(fetchFunction, flag);

	function fetchFunction() {
    if(!simultaneosRecs)
    {
      getHistory();
    }else{
      selectedRecord.flagLogDial ? getHistory() : setFetchingPage(false);
    }
  }
  
  useEffect(() => {
    getLanguague();
    checkIfthereAreLogDial();
    setStyleSimultaneousRecs();
  }, [])

  useEffect(() => {
    setStyleSimultaneousRecs();
  }, [showOnlyData])
  
  
  const checkIfthereAreLogDial = () => { 
    if(!simultaneosRecs)
    {
      getHistory();
    }else{
      setLogPerRec();
    }
   }
  const setLogPerRec = () => { 
    let logDialPerRec = records.filter(r => r.callOutId === callOutId);
    
    if((logDialPerRec[0].logDial).length === 0)
    {
      getHistory();
    }
    else{
      setDialingLog(logDialPerRec[0].logDial);
    }
   }

  const getLanguague = () => {
    idLanguage !== '-1' && setLang(LANGUAGE[idLanguage]);
  }
  const getHistory = () =>{ 
    if(flag){
      setFetchingPage(false);
    }  
    else{
    let dataSend= {
      callOutId: callOutId, 
      camId: camId,
      userId: userId,
      initialRow:iRow,
      finalRow:fRow
    };
    let objectResponse = apiCont.getObjectResponse();
    apiCont.getPreviewHistory(dataSend, objectResponse);

    objectResponse.onError = function (messageError) {
      Logger.Error('[DialingLogPreview][getHistory]',messageError)
      setFetchingPage(false);
      
    };
    objectResponse.onSuccess = function (objResponse) {
      setFetchingPage(false);  
      let arr = objResponse.Response;
      if(simultaneosRecs && (arr.length < (fRow - iRow)))
      {
        dispatch(setFlagLogDial(callOutId))
      }
      if(arr.length>0) {
        setIRow(fRow+1);
        setFRow(fRow+30);
        setDialingLog([...dialingLog, ...arr]);
        if(simultaneosRecs)
        {
          selectedRecord.flagLogDial && dispatch(saveLogDial({callOutId:callOutId,logDial:[...dialingLog, ...arr]}))
        }
      }
      else{
        setFlag(true);
        simultaneosRecs && dispatch(setFlagLogDial(callOutId))
      }     
      }
    }   
  }
  const setStyleSimultaneousRecs = () => {
    if(simultaneosRecs)
    {
      if(status === RECORD_STATE.DEFAULT || status === RECORD_STATE.DIALOG)
      {
        setRigthSideStyle(status)
      } else if (wrapUpStyle.includes(status))
      {
        showOnlyData ?  setRigthSideStyle('') : setRigthSideStyle('WRAPUPWITHDISP');
      }
    }
  }
  return (
    
    <div className={`rightSide ${rigthSideStyle} ${simultaneosRecs ? 'simultaneous':''}`}>         
           {!simultaneosRecs && <div className={`dlp-title-record `}>
              <p className='label-title-record'>{language.getText('GUIPreviewdialingLog')}</p>
              <i className='gcl-icon history' />
            </div>}
            <div className={`container-cards ${simultaneosRecs ? 'designSimultaneous':''} ${(simultaneosRecs && dialingLog.length === 0) ? 'simultaneosRecs':''}`} ref={containerRef}>
              { dialingLog.length > 0 ? 
                dialingLog.map((r,index) => <CardData key={index} result={language.getText(`GUIDialResult${r.DialResult}`)} disposition={r.Disposition} date={formatDateWithHour(r.Date,lang)} simultaneosRecs={simultaneosRecs} />)
                : <MsgError label={language.getText('GUIPreviewmsgRecentCalls')} showDataLogDisp={showDataLogDisp} simultaneosRecs={simultaneosRecs}/> } 
              { isFetchingPage && <Spinner size='sm' color='primary' />}  
            </div>
    </div>
  )
}
const MsgError = ({label, showDataLogDisp, simultaneosRecs}) => {
    return (
  
      <div className={`container-no-dialing-log ${showDataLogDisp ? 'showDataLogDisp':''} ${!simultaneosRecs ? "noSimultaneous" : ''}`}>
        <div className="icon-no-dialing-log">
         <i id='icon-no-dialing'className="gcl-icon warning "/>
        </div>
        <div className='label-no-dialing-log'>{label}</div>
      </div>   
    );
  };
  
  const CardData = ({result, disposition,date,simultaneosRecs}) => {
    const newDisposition = (disposition !== "") ?  disposition : language.getText('GUIDialResultdoesNotApply');
    return (
     <div className={`card-item ${!simultaneosRecs ? 'noSimultaneous':''}`}>
      <div><p className='subtitle-item-card'>{`${language.getText('GUIPreviewresult')}: `}</p>    <p className='label-item-card'>{result}</p></div>
      <div><p className='subtitle-item-card'>{`${language.getText('GUIPreviewdisposition')}: `} </p> <p className='label-item-card'>{newDisposition}</p></div>
      <div><p className='subtitle-item-card'>{`${language.getText('GUIPreviewdateAndTime')}: `} </p> <p className='label-item-card'>{date}</p></div>
     </div>
      );
  };
export default DialingLogPreview


// WEBPACK FOOTER //
// ./src/components/workSpace/Others/DialingLogPreview.jsx